import { render, staticRenderFns } from "./BookingAlertAdminMarkCompleted.vue?vue&type=template&id=10020e89"
import script from "./BookingAlertAdminMarkCompleted.vue?vue&type=script&lang=js"
export * from "./BookingAlertAdminMarkCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports